export default {
  common: {
    nav: {
      home: "خانه",
      find_offer_help: "یافتن / ارائه کمک",
      celebrate: "بزرگداشت یک زندگی",
      family_tree: "شجره‌نامه",
      events: "رویدادها",
      civic_reports: "گزارش‌های شهروندی",
      neighborhood_pulse: "نبض محله",
      weather: "آب و هوا",
      nature: "طبیعت",
      marketplace: "بازار",
      news: "اخبار",
      causes: "اهداف نیک",
      more: "بیشتر",
    },
    header: { sign_in: "ورود", join: "به Social Pulse بپیوندید", language: "زبان", search: "جستجو" },
    tagline: "پیوند جوامع · توانمندسازی زندگی‌ها · ساخت سرمایه اجتماعی",
    locality: { viewing_from: "شما در حال مشاهده از", change: "تغییر", set_your_location: "موقعیت خود را تنظیم کنید" },
    news: { title: "خلاصه روزانه شما.", play_briefing: "پخش خلاصه روزانه", listen: "گوش دهید", translate: "ترجمه" },
  },
};
